// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"47808b47","100":"99a84284","152":"2b6a913c","173":"50a19dcc","457":"f3d2eb6b","719":"192ffaea","899":"665ebbd9","973":"d1529933"}[chunkId] + ".chunk.css";
};